import {CALL_API} from 'redux/middleware/api'
import {
  APP_SETTINGS
} from '.'

export function appSettings() {
  return {
    [CALL_API]: {
      method: 'GET',
      endpoint: 'app-settings',
      errorsHandled: true,
      types: APP_SETTINGS
    }
  }
}



// WEBPACK FOOTER //
// ./client/redux/modules/app-settings/actions.js